import React, { useEffect, useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AuthBtn from "../Buttons/AuthBtn";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { EditCustomerApi } from "../../ApiRequests";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";

const EditCustomerPageModal = ({ Open, setOpen, customer, onSuccess }) => {
  const [pageNo, setPageNo] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (Open) {
      setPageNo(
        customer?.page_no != null && customer?.page_no !== ""
          ? String(customer.page_no)
          : ""
      );
    }
  }, [Open, customer?._id, customer?.page_no]);

  const onSubmit = async (e) => {
    e?.preventDefault?.();
    if (!customer?._id) {
      WarningToast("Customer not found");
      return;
    }
    setLoading(true);
    try {
      const response = await EditCustomerApi(customer._id, {
        name: customer.name,
        contact: customer.contact,
        contact2: customer.contact2 || "",
        address: customer.address,
        type: customer.type,
        ref: customer.ref || "",
        page: String(pageNo || "").trim(),
      });
      if (response.data.success) {
        SuccessToast("Page No updated");
        setOpen(false);
        if (typeof onSuccess === "function") {
          onSuccess(String(pageNo || "").trim());
        }
      } else {
        ErrorToast(response.data.error?.msg || "Failed to update Page No");
      }
    } catch (err) {
      ErrorToast(
        err?.response?.data?.error?.msg ||
          err.message ||
          "Failed to update Page No"
      );
    }
    setLoading(false);
  };

  return (
    <CustomModal open={!!Open} setOpen={setOpen}>
      <form onSubmit={onSubmit} className="pb-8 w-[min(92vw,380px)]">
        <h1 className="w-full text-center font-[700] text-2xl py-6 px-4 text-ink">
          Edit Page No
        </h1>
        <p className="text-center text-sm text-inkSecondary px-6 mb-4">
          {customer?.name || "Customer"}
        </p>
        <div className="px-6">
          <AuthInput
            label="Page No"
            placeholder="Enter page no"
            Value={pageNo}
            setValue={setPageNo}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-6 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title="Cancel" onSubmit={() => setOpen(false)} type={2} />
              <AuthBtn title="Save" onSubmit={onSubmit} type={1} />
            </>
          )}
        </div>
      </form>
    </CustomModal>
  );
};

export default EditCustomerPageModal;
